import type { FC } from 'react';
import { Card, CardGroup, Spinner } from '@george-labs.com/design-system';

import { ConditionalWrapper } from '@luna/utils-ui';

interface Props {
    'data-cy': string;
    className?: string;
    showInCardGroup?: true;
}

export const Loader: FC<Props> = ({ 'data-cy': dataCy, className, showInCardGroup = false }) => (
    <ConditionalWrapper
        condition={showInCardGroup}
        wrapper={CardGroup}
        wrapperProps={{ className: 'mx-3' }}
    >
        <Card data-cy={dataCy} className={className}>
            <Spinner className="py-4" center />
        </Card>
    </ConditionalWrapper>
);
